import {inject, Injectable} from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {catchError, map, switchMap} from 'rxjs/operators';
import {TokenErrorHandlerService} from '../../services/token-error-handler.service';
import {AuthService} from '../../auth/shared/services/auth.service';
import {AxiosError} from 'axios';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  auth = inject(AuthService);
  tokenErrorHandlerService = inject(TokenErrorHandlerService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse | AxiosError) => {
        this.tokenErrorHandlerService.processHttpError(error);
        return throwError(() => error);
      }),
      switchMap((event: HttpEvent<unknown>) => {
        if (event instanceof HttpResponse && event.body && (event.body as {code?: number}).code === 401) {
          return this.auth.refreshTokens().pipe(switchMap(() => next.handle(request)));
        }
        return of(event);
      }),
    );
  }

  // TODO: Commented for testing DASH-670, in a month if no related problems are found, you can remove the function entirely
  // private patchRequest(request: HttpRequest<unknown>): HttpRequest<unknown> {
  //   const {consoleUrl, isFeatureBranchingMode} = environment;
  //   const targetUrl = consoleUrl.substring(0, consoleUrl.length - 1);
  //   const hasDelimiter = request.url.startsWith('/');
  //
  //   return isFeatureBranchingMode
  //     ? request.clone({
  //         url: request.url.includes('api/') ? `${targetUrl}${hasDelimiter ? '' : '/'}${request.url}` : request.url,
  //       })
  //     : request;
  // }
}
